export default __webpack_public_path__ + "img/complete-women.0c3d62ce.png";